import { css as universeCss } from '../../components/universe';

export function withGlow(star: HTMLDivElement | null): gsap.TweenVars {
  return {
    onStart: () => {
      star?.classList.add(universeCss.shadow);
    },

    onReverseComplete: () => {
      star?.classList.remove(universeCss.shadow);
    },
  };
}
